import { useEffect, useState } from 'react'

function CustomCursor() {
    const [ripples, setRipples] = useState([])

    useEffect(() => {
        const handleMouseDown = (e) => {
            const newRipple = {
                id: Date.now(),
                x: e.clientX,
                y: e.clientY
            }
            setRipples(prev => [...prev, newRipple])

            // Remove ripple after animation
            setTimeout(() => {
                setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id))
            }, 2000)
        }

        window.addEventListener('mousedown', handleMouseDown)

        return () => {
            window.removeEventListener('mousedown', handleMouseDown)
        }
    }, [])

    return (
        <>
            {/* Click ripples */}
            {ripples.map(ripple => (
                <div
                    key={ripple.id}
                    className="cursor-ripple"
                    style={{
                        left: `${ripple.x}px`,
                        top: `${ripple.y}px`,
                    }}
                >
                    <div className="ripple-ring" />
                    <div className="ripple-ring ripple-ring-2" />
                    <div className="ripple-ring ripple-ring-3" />
                </div>
            ))}
        </>
    )
}

export default CustomCursor
